export const DEFAULT_PAGINATION = {
  PAGE_SIZE_DEFAULT: 50,
  INITIAL_PAGE: 1,
  PAGE_ALL: "all",
};

export const MIN_SEARCH_LENGTH = 3;

export const FIELDS = {
  SESSION_NUMBER: "session_number",
  TOTAL_UNIQUE_CUSTOMERS: "total_unique_customers",
  ATTENDANCE_PERCENTAGE: "attendance_percentage",
  FULL_ATTENDANCE: "full_attendance",
  PARTIAL_ATTENDANCE: "partial_attendance",
  ABSENT: "absent",
  UNRECOGNIZED: "unrecognized",
  CUSTOMER_NAME: "name",
  NAME: "name",
  USER_EMAIL: "user_email",
  CUSTOMER_EMAIL: "customer_email",
  CUSTOMER_PHONE: "customer_phone",
  HAS_ATTENDED: "has_attended",
  TOTAL_MINUTES_ATTENDED: "total_minutes_attended",
  TIMES_JOINED: "times_joined",
  JOIN_TIME: "join_time",
  LEAVE_TIME: "leave_time",
  DURATION: "duration",
  STATUS: "status",
  ACTION: "action",
  ATTENDANCE_TYPE: "attendance_type",
  MINUTES_FROM: "minutes_from",
  MINUTES_TO: "minutes_to",
  ATTENDANCE_FROM: "attendance_from",
  ATTENDANCE_TO: "attendance_to",
  DURATION_RANGE: "duration_range",
  DURATION_PCT_RANGE: "duration_pct_range",
  EXLY_USER_UUID: "exly_user_uuid",
  ID: "id",
  SLOT_UUID: "slot_uuid",
};

export const ATTENDANCE_THRESHOLDS = {
  HIGH: 60,
  ZERO: 0,
};

export const NUMERIC = {
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
  FOUR: 4,
  EMPTY_STRING: "",
};

export const WIDTHS = {
  WIDTH_80PX: "80px",
  WIDTH_120PX: "120px",
  WIDTH_130PX: "130px",
  WIDTH_150PX: "150px",
  WIDTH_180PX: "180px",
  WIDTH_200PX: "200px",
};

export const LAYOUT = {
  PADDING_DESKTOP_ZERO: "0",
  PADDING_BOTTOM_60PX: "60px",
  PRIMARY_KEY_SLOT: "slot_uuid",
  PRIMARY_KEY_ID: "id",
};

export const FIELDS_ALIGNMENT_SPACE_BETWEEN = "space-between";

export const FOOTER_VARIANT_SECONDARY = "secondary";

export const TAB_VALUES = {
  FULL: "attendance-type_full",
  PARTIAL: "attendance-type_partial",
  NO: "attendance-type_no",
  UNRECOGNIZED: "attendance-type_unrecognized",
};

export const QUERY_CACHE_TIME_MS = 30000;
